import { render, staticRenderFns } from "./FichaUso.vue?vue&type=template&id=0a28a717&"
import script from "./FichaUso.vue?vue&type=script&lang=js&"
export * from "./FichaUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports